import { NotificationContainer } from '@elotech/components';
import { createContext, useContext, useRef } from 'react';
import NotificationSystem from 'react-notification-system';

const NotificationContext = createContext<
  | Pick<
      NotificationSystem,
      | 'addNotification'
      | 'removeNotification'
      | 'clearNotifications'
      | 'editNotification'
    >
  | undefined
>(undefined as any);

export const useNotification = () => useContext(NotificationContext);

export const NotificationWrapper = ({ children }) => {
  const notificationRef = useRef<any>();

  return (
    <>
      <div
        className="no-print"
        style={{ zIndex: 999991, position: 'relative' }}
        aria-live="polite"
        role="status"
      >
        <NotificationSystem ref={notificationRef as any} />
      </div>
      <NotificationContext.Provider value={notificationRef.current}>
        <NotificationContainer>{children}</NotificationContainer>
      </NotificationContext.Provider>
    </>
  );
};
